import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../auth/auth.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { forkJoin, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class StudentApiServiceService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private authService: AuthService, private toasterService: ToasterService) { }

  getStudentList(page?: number, params?: any): Observable<any> {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', page.toString());
    }
    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value !== null && value !== undefined && value !== '') {
          queryParams = queryParams.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}student/get-all`, { params: queryParams });
  }

   getStudentSearch( params?: any): Observable<any> {
    let queryParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value !== null && value !== undefined && value !== '') {
          queryParams = queryParams.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}student/get-all`, { params: queryParams });
  }

  getStudentById(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}student/get-by-id/${id}`);
  }
  getStudentbyGroup(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}group/sync-all-students/${id}`);
  }
  getStudentbyClass(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}class/sync-all-students/${id}`);
  }


  getStudentFullDetails(id: any) {
    return forkJoin({
      student_personal_details: this.http.get(`${this.apiUrl}student/get-by-id/${id}`),
      student_parent_details: this.http.get(`${this.apiUrl}student/get-parent-detail/${id}`),
      students_address_details: this.http.get(`${this.apiUrl}student/get-address/${id}`),
    });
  }

  createStudentProfileDetails(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/create`, data);

  }

  updateStudentProfileDetails(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/update/${id}`, data);
  }

  deleteStudentProfileDetails(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}student/delete/${id}`);
  }


  setStudentAddressDetails(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/create/address/${id}`, data);
  }

  setStudentParentDetails(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/create/parent-detail/${id}`, data);
  }

  updateStudentAddressDetails(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/create/address/${id}`, data);
  }

  updateStudentParentDetails(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}student/create/parent-detail/${id}`, data);
  }


  setStudentActiveStatus(id: any, status: any): Observable<any> {
    return this.http.get(`${this.apiUrl}student/update/${id}/${status}`);
  }




}
